import { simpleGlobalState } from '@pbk-web/state';

export const useInConsultantSpace = simpleGlobalState(false);

export const useTopNavHeading = simpleGlobalState<string | null>(null);

export const useInAdminSpace = simpleGlobalState(false);
